<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="#7C3DFF">
        <v-toolbar-title class="m-0 white--text"
          >Dados do Plano</v-toolbar-title
        >
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark flat @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Plano</span
              >
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="Nome do Plano"
                      v-model="name"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o nome do plano!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="ID do Plano"
                      v-model="id"
                      :rules="[
                        (v) => !!v || 'Por favor, coloque um ID para o plano',
                      ]"
                      :readonly="type === 'edit'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Desconto do Plano"
                      hint="Somente números"
                      v-model="discount"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o desconto do plano!',
                        (v) => v >= 0 || 'Desconto deve ser um valor válido!',
                        (v) => v <= 99 || 'Desconto deve ser um valor válido!',
                      ]"
                      mask="##"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Tempo de Contrato (em meses)"
                      hint="Somente números"
                      v-model="contract_time"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o tempo de contrato!',
                      ]"
                      mask="#####"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md4>
                    <v-menu
                      v-model="calendar"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="started_at"
                          label="Início do Plano"
                          append-outer-icon="event"
                          readonly
                          required
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, informe a data de início do plano!',
                          ]"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dark
                        v-model="started_at"
                        @input="calendar = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      label="Concessionária"
                      :items="utilityCompanies"
                      :item-text="utilityCompanyText"
                      return-object
                      v-model.lazy="utility_company"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, selecione a concessionária para o plano!',
                      ]"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      label="URL do Estatuto da Cooperativa"
                      v-model="cooperative_statute_url"
                      readonly
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-autocomplete
                      :items="companies"
                      label="Empresa"
                      v-model="company"
                      :rules="[(v) => !!v || 'Por favor, informe a empresa!']"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-radio-group
                      v-model="person_type"
                      :rules="[
                        (v) => !!v || 'Por favor, selecione o tipo de pessoa!',
                      ]"
                      row
                      required
                    >
                      <v-radio label="Pessoa Física" value="pf"></v-radio>
                      <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-checkbox
                      label="Plano recomendado?"
                      v-model="recommended"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-checkbox
                      label="Plano promocional?"
                      v-model="promotional"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="error" @click="closeDialog()"> Fechar </v-btn>
              <v-btn
                flat
                color="success"
                @click="validate()"
                :loading="loading"
                :disabled="buttonDisable()"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: "new",
    },
    plan: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    valid: false,
    loading: false,
    rules: [],
    name: "",
    contract_time: "",
    person_type: "",
    recommended: "",
    promotional: false,
    discount: "",
    id: "",
    calendar: false,
    started_at: new Date(),
    utility_company: "",
    cooperative_statute_url: null,
    company: "",
    companies: [
      {
        text: "Elétron",
        value: "eletron",
      },
      {
        text: "Juntos",
        value: "juntos",
      },
    ],
  }),

  computed: {
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapGetters("configuration", ["utilityCompanyById", "cooperativeById"]),

    mainCooperative() {
      return this.utility_company
        ? this.cooperativeById(this.utility_company.mainCooperative)
        : "";
    },
  },

  watch: {
    mainCooperative() {
      this.cooperative_statute_url = this.mainCooperative
        ? this.mainCooperative.terms_url
        : "";
    },
  },

  methods: {
    ...mapActions("configuration", [
      "addPlans",
      "updatePlans",
      "getUtilityCompanies",
      "getCooperatives",
    ]),

    buttonDisable() {
      return !this.valid || this.name === null;
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        this.loading = true;
        let data = {
          name: this.name,
          contract_time: this.contract_time,
          person_type: this.person_type,
          recommended: this.recommended,
          promotional: this.promotional,
          discount: this.discount,
          id: this.id,
          status: "activated",
          started_at: new Date(this.started_at),
          utility_company: this.utility_company.id,
          cooperative_statute_url: this.cooperative_statute_url,
          company: this.company,
        };
        if (this.type === "new") {
          await this.addPlans(data);
        } else if (this.type === "edit") {
          await this.updatePlans(data);
        }
      }
      this.loading = false;
      this.closeDialog();
    },

    utilityCompanyText(item) {
      return `${item.name} - ${item.state}`;
    },

    closeDialog() {
      this.$emit("closeDialog");
    },
  },

  mounted() {
    this.loading = true;
    this.name = this.plan?.name || "";
    this.contract_time = this.plan?.contract_time || "";
    this.person_type = this.plan?.person_type || "";
    this.recommended = this.plan?.recommended || "";
    this.promotional = this.plan?.promotional || false;
    this.discount = this.plan?.discount || "";
    this.id = this.plan?.id || "";
    this.status = this.plan?.status || "";
    this.company = this.plan?.company || "";
    this.started_at =
      moment(this.plan?.started_at.toDate()).format("YYYY-MM-DD") || "";
    this.utility_company = this.plan
      ? this.utilityCompanyById(this.plan.utility_company)
      : "";
    this.cooperative_statute_url = this.plan?.cooperative_statute_url || "";
    this.getUtilityCompanies();
    this.getCooperatives();
    this.loading = false;
  },
};
</script>
